import { AmericanExpressIcon } from 'src/components/icons/AmericanExpressIcon'
import { ApplePayIcon } from 'src/components/icons/ApplePayIcon'
import { ClickToPayIcon } from 'src/components/icons/ClickToPayIcon'
import { GooglePayIcon } from 'src/components/icons/GooglePayIcon'
import { MaestroIcon } from 'src/components/icons/MaestroIcon'
import { MastercardIcon } from 'src/components/icons/MastercardIcon'
import { PaypalIcon } from 'src/components/icons/PaypalIcon'
import { PostePayicon } from 'src/components/icons/PostePayIcon'
import { ScalapayFooterIcon } from 'src/components/icons/ScalapayFooterIcon'
import { VisaIcon } from 'src/components/icons/VisaIcon'
import { VtexIcon } from 'src/components/icons/VtexIcon'

type BusinessDataProp = {
  businessData: string
}

export const BusinessData = ({ businessData }: BusinessDataProp) => {
  return (
    <div className="w-full 2xl:max-w-[1440px] 2xl:mx-auto">
      <div className="py-6 lg:py-2 px-6 md:px-10 text-white flex flex-col gap-4 lg:flex-row-reverse lg:flex-nowrap lg:gap-[38px] lg:justify-between">
        <div className="flex flex-col lg:flex-row justify-center lg:justify-start gap-4 sm:gap-8 items-center">
          <VtexIcon />
          <div className="flex flex-row flex-wrap lg:flex-nowrap gap-1 lg:gap-2 justify-center items-center">
            <ApplePayIcon />
            <GooglePayIcon />
            <VisaIcon />
            <ClickToPayIcon />
            <MaestroIcon />
            <AmericanExpressIcon />
            <PostePayicon />
            <PaypalIcon />
            <ScalapayFooterIcon />
          </div>
        </div>
        <div className="lg:py-4">
          <p className="block text-center lg:text-left text-[10px] !leading-[120%] tracking-[0.2px] font-[325]">
            {businessData}
          </p>
        </div>
      </div>
    </div>
  )
}
